import { render, staticRenderFns } from "./PageTips.vue?vue&type=template&id=f7a7cb2c&scoped=true"
import script from "./PageTips.vue?vue&type=script&lang=js"
export * from "./PageTips.vue?vue&type=script&lang=js"
import style0 from "./PageTips.vue?vue&type=style&index=0&id=f7a7cb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a7cb2c",
  null
  
)

export default component.exports